import { trpc } from '@/shared/api';

interface InvalidateSiteSettings {
  /** 운영 설정을 다시 불러온다 — 재조회 promise 를 돌려준다. */
  readonly invalidate: () => Promise<void>;
}

/** 운영 설정 다시 불러오기 — 쓰기 훅이 재조회 promise 를 기다려 새 값이 오기 전에 버튼이 풀리지 않게 한다. */
export const useInvalidateSiteSettings = (): InvalidateSiteSettings => {
  const utils = trpc.useUtils();
  return { invalidate: () => utils.siteSettings.get.invalidate() };
};
